module.exports = __webpack_public_path__ + "static/img/icon_slide_next_dark.368dc66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_slide_next_dark.svg
// module id = /krb
// module chunks = 10